import type { Route } from "../Route.ts"

import { Link as RemixLink, type LinkProps } from "@remix-run/react"

export const Link = (props: Omit<LinkProps, "to"> & { to: Route }) => (
  <RemixLink {...props} to={props.to} />
)
